import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import rootReducer from 'offshore_pcb/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['cart/doAddToCart/fulfilled'],
        ignoredPaths: ['payload.0.headers'],
      },
    }),
  ],
});

export default store;
